import { render } from "./DateRangeInput.vue?vue&type=template&id=5210f5b3"
import script from "./DateRangeInput.vue?vue&type=script&lang=js"
export * from "./DateRangeInput.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__